var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 pa-sm-2 justify-center d-flex",attrs:{"fill-height":"","fluid":""}},[_c('v-flex',{attrs:{"xs12":"","sm11":"","md10":"","lg9":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }